import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Carousel } from 'components/carousel'
import { Col, Grid } from 'components/grid'

import { cards } from './data'
import { CardProps } from './know-and-discover.model'
import * as S from './styles'

const KnowAndDiscover: FC = memo(() => (
  <S.Section $bg="medium">
    <Grid col={{ phone: 1, tablet: 1, desktop: 12 }}>
      <Col col={{ desktop: 9 }} start={{ desktop: 2 }}>
        <Text as="h2" weight="medium" size="heading3" color="var(--colors-neutral-text-default)">
          Conheça alguns{' '}
          <Text as="span" weight="medium" size="heading3" color="var(--colors-pink-text-default)">
            tipos de golpes{' '}
          </Text>
          e descubra como eles acontecem
        </Text>
      </Col>
      <Col col={{ desktop: 12 }} start={{ desktop: 1 }}>
        <S.RightSideWrapper>
          <S.CarouselBg />
          <S.CarouselWrapper>
            <Carousel navigation={true}>
              {cards.map(({ id, title, description }: CardProps) => (
                <S.Card key={id}>
                  <Text as="h3" size="heading4" weight="medium">
                    {title}
                  </Text>
                  <S.CardContent>
                    {description}
                  </S.CardContent>
                </S.Card>
              ))}
            </Carousel>
          </S.CarouselWrapper>
        </S.RightSideWrapper>
      </Col>
    </Grid>
  </S.Section>
))

KnowAndDiscover.displayName = 'KnowAndDiscover'

export default KnowAndDiscover
